// src/utils/HttpErrorHandler.js
import Vue from "vue";
// Notification
// import { useToast } from 'vue-toastification/composition'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
// import { t } from '@/@core/libs/i18n/utils'
import { getHttpContext } from "./HttpContext";

export default function handleHttpError(error, messageInput) {
  const toast = Vue.$toast;
  const { store, router } = getHttpContext();

  // Use toast
  // const toast = useToast()

  // let message = message
  let message = messageInput;

  let title = "Information";
  const type = "danger";

  if (error.response) {
    const { status, data } = error.response;

    switch (status) {
      case 401:
        title = data;
        setTimeout(() => {
          if (store && router) {
            store.dispatch("user/logoutComplet"); // 🔁 Nettoie le frontend + appelle /auth/logout
            if (router.currentRoute.path !== "/login") {
              router.push({ name: "login" });
            }
           
          }
        }, 1000);

        break;
      case 403:
        title = "Accès refusé.";
        message =
          "Accès refusé. Vous n'avez pas l'autorisation d'accéder à cette ressource.";
        break;
      case 404:
        title = "Ressource non trouvée.";
        break;
      case 500:
        title = "Erreur interne du serveur.";
        break;
      // case 400:
      //   title = "Erreur interne du serveur.";
      //   break;
      default:


         message = messageInput;

        if (error.response?.data) {

          const data = error.response.data;

            if (Array.isArray(data.errors) && data.errors.length > 0&&
                !error.response.data?.errors[0]?.fieldId) {
              console.log(data.errors)
              const backendErrors = error.response.data.errors;

              message = backendErrors.map(e => {


                if (e.invalidChar && e.position != null) {
                  return `${e.message} :  <span class="text-danger fw-bold">${e.invalidChar}</span> à la position ${e.position}. Texte reçu : "${e.input}"`;
                }


                if (!e.invalidChar && e.position == null) {
                  return `${e.message}. Texte reçu : "${e.input}"`;
                }


                return e.message || "Erreur inattendue.";

              }).join(' | ');
            }


          else if (data.message) {
            message = data.message;
          }
        }
        break;
    }
  } else if (error.request) {
    message = "Le serveur ne répond pas. Vérifiez votre connexion.";
  }


  toast({
    component: ToastificationContent,
    variant: type,
    props: {
      title,
      icon: "AlertTriangleIcon",
      variant: "danger",
      text: message,
      timeout: 2000,
    },
  });

  console.error("Erreur HTTP :", error);
}
